import React from 'react';
import { Link } from 'react-router-dom';

type PropsLinkCurso = Readonly<{
    codigo: string;
    color?: string;
}>;

export const LinkCurso = (props: PropsLinkCurso) => {
    const { codigo, color, ...resto } = props;

    return (
        <Link style={{ color }} to={`/horarios/cursos/${IdDeCurso(codigo)}`} {...resto}>
            <b>{codigo}</b>
        </Link>
    );
};

function IdDeCurso(codigo: string) {
    return codigo.split('-')[1];
}



// WEBPACK FOOTER //
// ./src/componentes/LinkCurso/index.tsx